module.exports = '<svg width="41" height="32" viewBox="0 0 41 32"><path d="M38.857 0H2.286A2.284 2.284 0 0 0 0 2.286v27.429a2.284 2.284 0 0 0 2.286 2.286h36.571a2.284 2.284 0 0 0 2.286-2.286V2.286A2.284 2.284 0 0 0 38.857 0zM18.286 25.143H6.857V6.857h11.429v18.286zm16 0H22.857v-4.571h11.429v4.571zm0-6.857H22.857v-4.571h11.429v4.571zm0-6.857H22.857V6.858h11.429v4.571z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/id-1.js
// module id = 1177
// module chunks = 14